import controller from './privacy.controller';
import template from './privacy.html';

const privacyComponent = {
  restrict: 'E',
  bindings: {},
  controller,
  template
};

export default privacyComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/profile/account/privacy/privacy.component.js
 **/